import ZoneService from '../../services/zones';
import i18n from '../../i18n'

const namespaced = true;

const state = {
	zones: [],
	map: {}
}

const mutations = {
	setZones(state, zones) {
		let zonesByAreaMap = zones.reduce((map, zone) => {
			let areaId = zone.area.id;
			if (areaId in map) {
				map[areaId].push(zone);
			} else {
				map[areaId] = [zone];
			}
			return map;
		}, {});
		state.zones = zones;
		state.map = zonesByAreaMap;
	},
}

const getters = {
	zonesByAreaMap: (state) => state.map
}

const actions = {
	async getZonesBySite({}, { siteId }){
		try {
			const response = await ZoneService.getZonesBySite(siteId);
			return response;
		}catch (e) {
            throw e;
        }
	},
	async getZones({commit}, { siteId }){
		try {
			const response = await ZoneService.getZones(siteId);
			commit('setZones', response);
			return response;
		}catch (e) {
            throw e;
        }
	},
	async getZoneByArea({}, areaId) {
    try {
      const zones = await ZoneService.getZoneByArea(areaId)
      return zones
    } catch (e) {
      throw new Error(i18n.t("something-went-wrong"), e);
    }
	},
	async createZone({}, zone) {
    try {
      const newZone = await ZoneService.createZone(zone)
      return newZone
    } catch (e) {
      throw new Error(i18n.t("something-went-wrong"), e);
    }
	},
	async editZone({}, zone) {
    try {
      const editedZone = await ZoneService.editZone(zone)
      return editedZone
    } catch (e) {
      throw new Error(i18n.t("something-went-wrong"), e);
    }
	},
	async deleteZone({}, zoneId) {
    try {
      const deletedZone = await ZoneService.deleteZone(zoneId)
      return deletedZone
    } catch (e) {			
      throw new Error(i18n.t("something-went-wrong"), e);
    }
  },
}

export default {
	namespaced,
	state,
	getters,
	mutations,
	actions
}